import React from "react";
import { FiDownload, FiEdit, FiFile, FiFolder, FiTrash2 } from "react-icons/fi";
import downloadDoc from "../../../services/Documents/downloadDoc";

export const ItemsGrid = ({
  getCurrentLevelItems,
  selectedItem,
  setSelectedItem,
  toggleFolder,
  isDocumentDownloading,
  handleSignDocument,
  setIsDocumentDownloading,
  userId,
}) => {
  const handleDownloadDocument = async (e, document) => {
    e.stopPropagation();
    console.log(document);

    setIsDocumentDownloading({
      documentId: document.id,
      isDownloading: true,
      isError: false,
    });

    const isError = await downloadDoc(userId, document.metadataId.name);
    setIsDocumentDownloading({
      documentId: document.id,
      isDownloading: false,
      isError: isError,
    });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {getCurrentLevelItems().map((item) => (
        <div
          key={item._id}
          className={`bg-white p-4 rounded-lg shadow hover:shadow-md transition-shadow ${
            selectedItem?._id === item._id ? "ring-2 ring-blue-500" : ""
          }`}
          onClick={() => setSelectedItem(item)}
        >
          <div className="flex items-center">
            {item.type === "folder" ? (
              <FiFolder className="h-8 w-8 text-blue-500 mr-3" />
            ) : (
              <FiFile className="h-8 w-8 text-gray-500 mr-3" />
            )}
            <div className="flex-1 min-w-0">
              <h3 className="font-medium truncate">
                {item.folderName ?? item.title}
              </h3>
              {item.type === "file" && (
                <p className="text-sm text-gray-500">
                  {(item.metadataId.size / 1024).toFixed(1)} KB
                  {item.isSigned && (
                    <span className="ml-2 text-green-600 font-medium">
                      Firmado
                    </span>
                  )}
                </p>
              )}
            </div>
          </div>
          <div className="mt-4 flex justify-end space-x-2">
            {item.type === "folder" && (
              <button
                className="px-3 py-1 text-xs bg-gray-100 rounded hover:bg-gray-200"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleFolder(item._id);
                }}
              >
                Abrir
              </button>
            )}
            {item.type === "file" && (
              <>
                <button
                  className={`px-3 py-1 text-xs bg-blue-50 text-indigo-900 rounded hover:bg-blue-100 ${
                    isDocumentDownloading.documentId === item._id &&
                    isDocumentDownloading.isDownloading
                      ? "opacity-50"
                      : ""
                  }`}
                  onClick={(e) => handleDownloadDocument(e, item)}
                  disabled={isDocumentDownloading.isDownloading}
                >
                  <FiDownload size={12} />
                </button>
                {!item.isSigned && (
                  <button
                    className="px-3 py-1 text-xs bg-green-50 text-green-900 rounded hover:bg-green-100"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSignDocument(item);
                    }}
                  >
                    Firmar
                  </button>
                )}
              </>
            )}
            <button
              className="px-3 py-1 text-xs bg-red-50 text-yellow-600 rounded hover:bg-red-100"
              onClick={(e) => {}}
            >
              <FiTrash2 size={12} />
            </button>
          </div>
        </div>
      ))}

      {getCurrentLevelItems().length === 0 && (
        <div className="col-span-3 text-center py-12 text-gray-500">
          Esta carpeta está vacía. Crea una carpeta o sube un documento.
        </div>
      )}
    </div>
  );
};

export default ItemsGrid;
